/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/getDiscountCouponList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DISCOUNT_CODES, GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCommDisListMethods extends IPluginMethodMap {
  getCommDisList(args: any): Promise<any>;
}

export class getCommDisList implements IAgentPlugin {
  readonly methods: IGetCommDisListMethods;

  constructor() {
    this.methods = {
      getCommDisList: this.getCommDisList.bind(this),
    };
  }

  async getCommDisList(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log(pretty(args));
    let filter = {};
    if (args?.data?._id) {
      filter = {
        ...filter,
        _id: args?.data?._id
      }
    }
    if (args?.criteria?._data?.adminId___email) {
      filter = {
        ...filter,
        Admin___email: {
          contains: args?.criteria?._data?.adminId___email
        }
      }
    }
    if (args?.criteria?._data?.masqId___email) {
      filter = {
        ...filter,
        Masq___email: {
          contains: args?.criteria?._data?.masqId___email
        }
      }
    }

    if (args?.criteria?.statusFilter) {
      filter = {
        ...filter,
        DiscountCode___status: args?.criteria?.statusFilter
      }
    }

    try {
      if (client) {
        const _res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        let variables = {
          filter: {
            ...filter,
            DiscountCode___committeeId: {
              eq: _res?.data?.getMyProfile?.id
            }
          },
          options: {
            limit: args?.size ?? 10,
            skip: args?.offset ?? 0
          },
        };
        const res = await client.query({
          query: GET_DISCOUNT_CODES,
          variables: variables,
          fetchPolicy: "network-only",
        });

        console.log(res?.data?.getDiscountReferals);
        if (res?.data) {

          let _totalPages = res?.data?.getDiscountReferals?.count
            ? Math.ceil(parseInt(res?.data?.getDiscountReferals?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getDiscountReferals?.skip /
            res?.data?.getDiscountReferals?.limit +
            1;
          let _rowData = this.formatTable(
            res?.data?.getDiscountReferals?.content
          );
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getDiscountReferals?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getDiscountReferals?.count,
            totalPages: _totalPages,
          };
        }
        return config;
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    users &&
      users.forEach((data?: any) => {
        console.log(data)
        _rowData.push({
          id: data?._id,
          name: data?.discountCodes?.discountCode,
          status: data?.discountCodes?.status,
          admin: data?.discountCodes?.adminId?.email,
          committee: data?.discountCodes?.committeeId?.email,
          masq: data?.discountCodes?.masqId?.email ?? "-",
          discountType: data?.discountType
        });
      });
    console.log(_rowData)
    return _rowData;
  }
}
